import { defineStore } from "pinia";
import { SET_SPINLOADING, SET_LOADING } from "./types";

export const useLoadingIndicator = defineStore("loading-indicator", {
    state: () => ({
        loading: false,
        spinLoading: false,
        loaderText: ""
    }),
    actions: {
        [SET_LOADING](payload: boolean) {
            this.loading = payload;
        },
        [SET_SPINLOADING](payload: boolean, loaderText: string) {
            this.loaderText = loaderText;
            this.spinLoading = payload;
        }
    }
});
